//@ts-nocheck
import { inject, observer } from 'mobx-react';
import React from 'react';
import MainSectionLayout from '../layout/MainSectionLayout';
import { Instance } from 'mobx-state-tree';
import { DutyExchangeStore } from '../../store/DutyExchangeStore';
import { ActionCode, Page, TLCode } from '../../common/enums';
import {
  ApplicationStore,
  AuthenticationStore,
  DutyStore,
  PharmacyDetailedStore,
  PharmacyStore,
  SecretariatStore,
  UiStore,
  AnchorStore,
  GroupStore,
} from '../../store';
import { RouteComponentProps } from 'react-router-dom';
import styled from '@emotion/styled';
import { css } from 'emotion';
import { Pharmacy } from '../../store/models/Pharmacy';
import { DutyTypeStore } from '../../store/DutyTypeStore';
import { Card, Tab, Tabs } from '@blueprintjs/core';
import NewExchangeTab, { ExchangeSelectionType } from './NewExchangeTab';
import ExchangeHistoryTab from './ExchangeHistoryTab';
import { PharmacyDetails } from '../../store/models/PharmacyDetails';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { DutyAssignment } from '../../store/models/DutyAssignment';
import { SystemStatusStore } from '../../store/SystemStatusStore';
import { SystemStatusSubSystem } from '../../common/enums/SystemStatusSubSystem';
import { SystemStatus } from '../../store/models/SystemStatus';
import { DutyAssignmentStore } from '../../store/DutyAssignmentStore';
import { ModalStore } from '../../store/ModalStore';
import { DutyExchangeItemStore } from '../../store/DutyExchangeItemStore';
import { DutyExchangeItem } from '../../store/models/DutyExchangeItem';
import moment from 'moment';
import { DayOfWeek } from '../../common/enums/DateAndTime';

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

const CardStyle = css({
  height: '100%',
  '& .bp3-tabs': {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  '& .bp3-tab-panel': {
    flex: 1,
  },
});

interface ExchangePageProps extends RouteComponentProps<{ pharmacyId: string }>, WithTranslateProps {
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  ApplicationStore?: Instance<typeof ApplicationStore>;
  PharmacyStore?: Instance<typeof PharmacyStore>;
  PharmacyDetailedStore?: Instance<typeof PharmacyDetailedStore>;
  DutyExchangeStore?: Instance<typeof DutyExchangeStore>;
  DutyExchangeItemStore?: Instance<typeof DutyExchangeItemStore>;
  DutyAssignmentStore?: Instance<typeof DutyAssignmentStore>;
  DutyTypeStore?: Instance<typeof DutyTypeStore>;
  DutyStore?: Instance<typeof DutyStore>;
  SystemStatusStore?: Instance<typeof SystemStatusStore>;
  ModalStore?: Instance<typeof ModalStore>;
  UiStore?: Instance<typeof UiStore>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
  AnchorStore?: Instance<typeof AnchorStore>;
  GroupStore?: Instance<typeof GroupStore>;
}

interface ExchangePageState {
  isLoading: boolean;
  requestorDutiesIsLoading: boolean;
  neighborDutiesIsLoading: boolean;
  exchangeHistoryIsLoading: boolean;
  exchangeIsSaving: boolean;
  pharmacyExchangeRequesterSelected?: Instance<typeof PharmacyDetails>;
  pharmacyExchangeNeighborSelected?: Instance<typeof PharmacyDetails>;
  withAgreement?: boolean;
  withoutSubstitution?: boolean;
  comment?: string;
  pharmacyNeighboringList?: Array<Instance<typeof PharmacyDetails>>;
  duties?: Array<Instance<typeof DutyAssignment>>;
  neighborDuties?: Array<Instance<typeof DutyAssignment>>;
  requesterDutiesSelected: number[];
  neighborDutiesSelected: number[];
  bypassedRejected: number[];
  pharmacyUser: boolean;
  pharmacyId?: number;
  systemStatus?: Array<Instance<typeof SystemStatus>>;
  exchangeItemHistory: Array<Instance<typeof DutyExchangeItem>>;
  onlyFutureDutyExchange?: boolean;
  onSaveResult: string[];
  onCheckResult: string[];
  lastSideChanged: string;
  lastExchangeItems?: Array<Instance<typeof DutyExchangeItem>>;
  selectedExchangeType: ExchangeSelectionType;
  selectedDate?: Date;
  selectedDayOfWeek?: DayOfWeek;
}

@inject('ModalStore')
@inject('AuthenticationStore')
@inject('ApplicationStore')
@inject('PharmacyStore')
@inject('PharmacyDetailedStore')
@inject('DutyExchangeStore')
@inject('DutyExchangeItemStore')
@inject('DutyAssignmentStore')
@inject('DutyTypeStore')
@inject('DutyStore')
@inject('SecretariatStore')
@inject('SystemStatusStore')
@inject('UiStore')
@inject('AnchorStore')
@inject('GroupStore')
@observer
class ExchangePage extends React.Component<ExchangePageProps, ExchangePageState> {
  state = {
    isLoading: false,
    requestorDutiesIsLoading: false,
    neighborDutiesIsLoading: false,
    exchangeHistoryIsLoading: false,
    exchangeIsSaving: false,
    duties: [],
    neighborDuties: [],
    requesterDutiesSelected: [],
    neighborDutiesSelected: [],
    bypassedRejected: [],
    pharmacyUser: false,
    withAgreement: false,
    withoutSubstitution: false,
    comment: '',
    exchangeItemHistory: [],
    onlyFutureDutyExchange: true,
    onSaveResult: [],
    onCheckResult: [],
    lastSideChanged: '',
    lastExchangeItems: undefined,
    selectedExchangeType: ExchangeSelectionType.ByPharmacy,
    selectedDate: undefined,
    selectedDayOfWeek: undefined,
  } as ExchangePageState;

  _isMounted = false;

  async componentDidMount() {
    this._isMounted = true;
    this._isMounted && this.setState({ isLoading: true });
    const { PharmacyStore, AuthenticationStore, ApplicationStore, translate, AnchorStore } = this.props;
    AnchorStore!.checkListLoaded();
    await PharmacyStore!.loadListSafely(true, true);
    const userRoles = AuthenticationStore!.userActionCodes;

    const criteria: any = {
      subSystem: 'lastPublishedDuty',
      secretariatId: this.getSelectedSecretariatId(),
    };
    const systemStatus = await this.props.SystemStatusStore!.search(criteria);

    // @ts-ignore
    this._isMounted && this.setState({ systemStatus });

    if (userRoles.includes(ActionCode.PHARMACY_USER_CODE)) {
      if (AuthenticationStore!.pharmacyId === null) {
        ApplicationStore!.navigate(`${Page.Error}/${translate(TLCode.ERROR_NoPharmacyRelatedToThisUser)}`);
      }
      this.onExchangeRequesterSelected(PharmacyStore!.getById(AuthenticationStore!.pharmacyId!)!);
      this._isMounted &&
        this.setState({
          pharmacyUser: true,
        });

      const criteriaBP: any = {
        pharmacyId: AuthenticationStore!.pharmacyId,
        subSystem: SystemStatusSubSystem.EXCHANGE,
      };
      const systemStatus = await this.props.SystemStatusStore!.search(criteriaBP);

      // @ts-ignore
      this._isMounted && this.setState({ systemStatus });
    }

    if (this.props.UiStore!.pharmaciesSecretariatIdFilter === 0)
      this.props.UiStore!.setPharmaciesSecretariatIdFilter(this.getSelectedSecretariatId());

    this._isMounted && this.setState({ isLoading: false });
  }

  componentWillUnmount() {
    this.props.DutyExchangeItemStore!.clearData();
    this._isMounted = false;
  }

  async ensureHistoryLoaded() {
    if (this.state.exchangeItemHistory.length === 0 && !this.state.exchangeHistoryIsLoading) {
      this.loadHistory(moment().add(-1, 'days').startOf('day').format('YYYY-MM-DD'), undefined, undefined);
    }
  }

  switchWithPastDates = async (tooglePast: boolean, year: number) => {
    const currentValueOnlyUndownloadedValues = this.state.onlyFutureDutyExchange;
    //this.loadHistory(tooglePast ? !currentValueOnlyUndownloadedValues : currentValueOnlyUndownloadedValues, year);
    this._isMounted && tooglePast && this.setState({ onlyFutureDutyExchange: !currentValueOnlyUndownloadedValues });
  };

  loadHistoryV2 = async (
      startDate: date,
      pharmacyId: number,
      secretariatId: number,
  ) => {

    if (startDate == undefined) startDate = moment().add(-1, 'days').startOf('day').format('YYYY-MM-DD');
    const criteria = this.props.AuthenticationStore!.isPharmacy
      ? {
        pharmacyId: pharmacyId,
        secretariatId: null,
        startDutyDate: startDate
      }
      : {
        pharmacyId: null,
        secretariatId: secretariatId,
        startDutyDate: startDate
      };
    this._isMounted && this.setState({ exchangeHistoryIsLoading: true });
    const responses = await Promise.all([
      this.props.DutyExchangeItemStore!.search(criteria as any),
      this.props.DutyStore!.searchForDutyExchangeItem(criteria as any),
    ]);
    //@ts-ignore
    this._isMounted && this.setState({ exchangeItemHistory: responses[0] });
    this._isMounted && this.setState({ exchangeHistoryIsLoading: false });
  }


  loadHistory = async (
    //currentValueOnlyUndownloadedValues: boolean | undefined,
    //year: number | undefined = undefined,
    startDate: Date, p1: number, p2: number
  ) => {

    if (startDate == undefined) startDate = moment().add(-1, 'days').startOf('day').format('YYYY-MM-DD');
    const criteria = this.props.AuthenticationStore!.isPharmacy //this.state.pharmacyUser
      ? {
        pharmacyId: this.props.AuthenticationStore!.pharmacyId,
        secretariatId: -1,
        startDutyDate: startDate, 
      }
      : {
        pharmacyId: -1,
        secretariatId: this.getSelectedSecretariatId(),
        startDutyDate: startDate
      };
    this._isMounted && this.setState({ exchangeHistoryIsLoading: true });
    const responses = await Promise.all([
      this.props.DutyExchangeItemStore!.search(criteria as any),
      this.props.DutyStore!.searchForDutyExchangeItem(criteria as any),
    ]);
    //@ts-ignore
    this._isMounted && this.setState({ exchangeItemHistory: responses[0] });
    this._isMounted && this.setState({ exchangeHistoryIsLoading: false });
  }

  private async getDutyExchangeDetails(dutyExchangeId: number) {
    const criteria = { dutyExchangeId: dutyExchangeId, secretariatId: this.getSelectedSecretariatId() };
    const responses = await Promise.all([
      this.props.DutyExchangeItemStore!.search(criteria as any),
      this.props.DutyStore!.searchForDutyExchangeItem(criteria as any),
    ]);
    //@ts-ignore
    this._isMounted && this.setState({ lastExchangeItems: responses[0] });
  }

  onExchangeRequesterSelected = async (value: Instance<typeof Pharmacy>) => {
    this._isMounted && this.setState({ requestorDutiesIsLoading: true });
    const { DutyExchangeStore, PharmacyDetailedStore } = this.props;
    await Promise.all([
      DutyExchangeStore!.loadPharmacyDuties(value!.pharmacyId),
      PharmacyDetailedStore!.loadElement(value.pharmacyId)!,
      PharmacyDetailedStore!.loadNeighboringPharmaciesForExchanges(
        value.pharmacyId,
        this.props.AuthenticationStore!.isPharmacy,
      ),
    ]).then((response) => {
      const duties = response[0] as Array<Instance<typeof DutyAssignment>>;
      const pharmacy: any = response[1];
      const neighboringList = response[2];

      this._isMounted &&
        this.setState({
          pharmacyExchangeRequesterSelected: pharmacy,
          // @ts-ignore
          pharmacyNeighboringList: neighboringList,
          duties,
          requestorDutiesIsLoading: false,
        });
    });
  };

  onExchangeNeighborSelected = async (value) => {
    this._isMounted && this.setState({ neighborDutiesIsLoading: true });
    const { DutyExchangeStore, PharmacyDetailedStore } = this.props;
    const neighborDuties = (await DutyExchangeStore!.loadPharmacyDuties(value!.pharmacyId)) as Array<
      Instance<typeof DutyAssignment>
    >;
    const pharmacy: any = value;
    this._isMounted &&
      this.setState({
        pharmacyExchangeNeighborSelected: pharmacy,
        requesterDutiesSelected: [],
        neighborDutiesSelected: [],
        bypassedRejected: [],
        neighborDuties,
        neighborDutiesIsLoading: false,
      });
  };

  isInConflict = async (dutyAssignmentId, pharmacyId) => {
    return await this.props.DutyExchangeStore!.isInConflict(dutyAssignmentId, pharmacyId);
  };

  hasAlreadyDutyOn = async (dutyAssignmentId, pharmacyId) => {
    await this.props.DutyAssignmentStore!.searchAssignment({ dutyAssignmentId });
    const assignment = this.props.DutyAssignmentStore!.getById(dutyAssignmentId);
    if (!assignment || !assignment.duty) return false;
    const dutyType = assignment.duty.dutyType !== undefined ? assignment.duty.dutyType.type : undefined;
    const dutyDate = assignment.duty.dutyDate.date;
    const result: any = await this.props.DutyAssignmentStore!.searchAssignment({
      pharmacyId,
      startDate: dutyDate,
      endDate: dutyDate,
      type: dutyType,
    });
    return result.length > 0;
  };

  onCheckNeighborDutiesSelected = async (ids) => {
    this.setState({
      onCheckResult: [],
    });
    if (ids.length == 0) return;
    const { DutyExchangeStore } = this.props;
    if( this.state.pharmacyExchangeNeighborSelected === undefined 
      || this.state.pharmacyExchangeRequesterSelected === undefined
    )
      return;
    const dutyExchange = {
      requestorId: this.state.pharmacyExchangeRequesterSelected!.pharmacyId,
      recipientId: this.state.pharmacyExchangeNeighborSelected!.pharmacyId,
      withAgreement: this.state.withAgreement,
      withSubstitution: this.state.withoutSubstitution!,
      comment: this.state.comment!,
      createdOn: moment().format('YYYY-MM-DD'), //new Date().toLocaleString(),
      createdBy: '',
      lastModifiedOn: moment().format('YYYY-MM-DD'), //new Date().toLocaleString(),
      lastModifiedBy: '',
    };

    //@ts-ignore
    const res = await DutyExchangeStore!.checkDutyExchange(dutyExchange, ids[ids.length - 1]);

    //@ts-ignore
    this.setState({
      onCheckResult: res,
      lastSideChanged: 'recipient',
    });

    return res;
  };

  onCheckRequesterDutiesSelected = async (ids) => {
    this.setState({ onCheckResult: [] });
    if (ids.length == 0) return;
    const { DutyExchangeStore } = this.props;
    const { requesterDutiesSelected, neighborDutiesSelected } = this.state;
    if( this.state.pharmacyExchangeNeighborSelected === undefined 
      || this.state.pharmacyExchangeRequesterSelected === undefined
    )
      return;
    const dutyExchange = {
      requestorId: this.state.pharmacyExchangeRequesterSelected!.pharmacyId,
      recipientId: this.state.pharmacyExchangeNeighborSelected!.pharmacyId,
      withAgreement: this.state.withAgreement,
      withSubstitution: this.state.withoutSubstitution!,
      comment: this.state.comment!,
      createdOn: moment().format('YYYY-MM-DD'),
      createdBy: '',
      lastModifiedOn: moment().format('YYYY-MM-DD'),
      lastModifiedBy: '',
    };

    this.setState({ onCheckResult: [] });

    const res = await DutyExchangeStore!.checkDutyExchange(dutyExchange, ids[ids.length - 1]);
    this.setState({ onCheckResult: res, lastSideChanged: 'requester' });

    return res;
  };

  checkTooCloseDuties = async (dutyAssignmentId, pharmacyId) => {

    const { DutyExchangeStore } = this.props;
    const { requesterDutiesSelected, neighborDutiesSelected } = this.state;
    const dutyExchange = {
      requestorId: this.state.pharmacyExchangeRequesterSelected!.pharmacyId,
      recipientId: this.state.pharmacyExchangeNeighborSelected!.pharmacyId,
      withAgreement: this.state.withAgreement,
      withSubstitution: this.state.withoutSubstitution!,
      comment: this.state.comment!,
      createdOn: moment().format('YYYY-MM-DD'),
      createdBy: '',
      lastModifiedOn: moment().format('YYYY-MM-DD'),
      lastModifiedBy: '',
    };


    const result = await DutyExchangeStore!.checkDutyExchange(dutyExchange, dutyAssignmentId);

    return result; 
  };

  checkTooCloseToRequester = async (dutyAssignmentId) => {
    const dutyAssignment = this.props.DutyAssignmentStore!.getById(dutyAssignmentId);
    const neighborPharmacyId = this.state.pharmacyExchangeNeighborSelected !== undefined ? this.state.pharmacyExchangeNeighborSelected!.pharmacyId : dutyAssignment!.pharmacyId;
    if(this.state.pharmacyExchangeNeighborSelected === undefined)
    {
      const pharmacy = this.props.PharmacyDetailedStore!.dataList.find(p => p.pharmacyId === neighborPharmacyId);
      this._isMounted && this.setState({ pharmacyExchangeNeighborSelected : pharmacy });
    }
    return (await this.checkTooCloseDutiesV2(dutyAssignmentId, neighborPharmacyId, this.state.pharmacyExchangeRequesterSelected!.pharmacyId));
  }

  checkTooCloseToRecipient = async (dutyAssignmentId) => {
    const dutyAssignment = this.props.DutyAssignmentStore!.getById(dutyAssignmentId);
    const requestorPharmacyId = this.state.pharmacyExchangeRequesterSelected !== undefined ? this.state.pharmacyExchangeRequesterSelected!.pharmacyId : dutyAssignment!.pharmacyId;
    if(this.state.pharmacyExchangeRequesterSelected === undefined)
    {
      const pharmacy = this.props.PharmacyDetailedStore!.dataList.find(p => p.pharmacyId === requestorPharmacyId);
      this._isMounted && this.setState({ pharmacyExchangeRequesterSelected : pharmacy });
    }
    return (await this.checkTooCloseDutiesV2(dutyAssignmentId, requestorPharmacyId, this.state.pharmacyExchangeNeighborSelected!.pharmacyId));
  }

  checkTooCloseDutiesV2 = async (dutyAssignmentId, fromId, toId) => {
    const { DutyExchangeStore } = this.props;
    const { requesterDutiesSelected, neighborDutiesSelected } = this.state;
    const dutyExchange = {
      requestorId: fromId,
      recipientId: toId,
      withAgreement: this.state.withAgreement,
      withSubstitution: this.state.withoutSubstitution!,
      comment: this.state.comment!,
      createdOn: moment().format('YYYY-MM-DD'),
      createdBy: '',
      lastModifiedOn: moment().format('YYYY-MM-DD'),
      lastModifiedBy: '',
    };


    const result = await DutyExchangeStore!.checkDutyExchange(dutyExchange, dutyAssignmentId);

    return result; 
  };

  onSave = async () => {
    this._isMounted && this.setState({ exchangeIsSaving: true });
    const { DutyExchangeStore } = this.props;
    const { requesterDutiesSelected, neighborDutiesSelected } = this.state;
    const dutyExchange = {
      requestorId: this.state.pharmacyExchangeRequesterSelected!.pharmacyId,
      recipientId: this.state.pharmacyExchangeNeighborSelected!.pharmacyId,
      withAgreement: this.state.withAgreement,
      withSubstitution: this.state.withoutSubstitution!,
      comment: this.state.comment!,
      createdOn: moment().format('YYYY-MM-DD'), //new Date().toLocaleString(),
      createdBy: '',
      lastModifiedOn: moment().format('YYYY-MM-DD'), //new Date().toLocaleString(),
      lastModifiedBy: '',
    };
    const res = await DutyExchangeStore!.saveDutyExchange(
      dutyExchange,
      requesterDutiesSelected,
      neighborDutiesSelected,
    );
    this.setState({ onSaveResult: res });
    const dutiesRequester = (await DutyExchangeStore!.loadPharmacyDuties(
      this.state.pharmacyExchangeRequesterSelected!.pharmacyId,
    )) as Array<Instance<typeof DutyAssignment>>;
    const dutiesNeighbor = (await DutyExchangeStore!.loadPharmacyDuties(
      this.state.pharmacyExchangeNeighborSelected!.pharmacyId,
    )) as Array<Instance<typeof DutyAssignment>>;
    await this.getDutyExchangeDetails(res);
    this._isMounted &&
      this.setState({
        duties: dutiesRequester,
        neighborDuties: dutiesNeighbor,
        requesterDutiesSelected: [],
        neighborDutiesSelected: [],
        withAgreement: false,
        withoutSubstitution: false,
        comment: '',
        exchangeIsSaving: false,
      });
    return res;
  };

  onWithoutSubstitutionChange = async () => {
    if (!this.state.withoutSubstitution && this.state.neighborDutiesSelected.length > 0) {
      const confirm = await this.props.ModalStore!.confirm.show(
        this.props.translate(TLCode.GENERAL_ConfirmationDemand),
        this.props.translate(TLCode.EXCHANGE_NeighborDutiesReinitialisation),
      );
      if (confirm) {
        this._isMounted &&
          this.setState({ neighborDutiesSelected: [], withoutSubstitution: !this.state.withoutSubstitution });
      }
    } else {
      this._isMounted && this.setState({ withoutSubstitution: !this.state.withoutSubstitution });
    }
  };

  onWithAgreementChange = () => {
    this.setState({ withAgreement: !this.state.withAgreement });
  };

  onCommentChange = (value) => {
    this.setState({ comment: value });
  };

  private getSelectedSecretariatId(): number | undefined {
    return this.props.AuthenticationStore!.isPharmacy &&
      this.props.SecretariatStore!.dataList.find(
        (s) =>
          s.secretariatId ===
          this.props.PharmacyStore!.dataList.find((p) => p.pharmacyId === this.props.AuthenticationStore!.pharmacyId)!
            .secretariatId,
      ) !== undefined
      ? this.props.PharmacyStore!.dataList.find((p) => p.pharmacyId === this.props.AuthenticationStore!.pharmacyId)!
        .secretariatId
      : this.props.AuthenticationStore!.isSecretariat && this.props.AuthenticationStore!.secretariatId
        ? this.props.AuthenticationStore!.secretariatId
        : this.props.SecretariatStore!.selectedSecretariatId === 0
          ? undefined
          : this.props.SecretariatStore!.selectedSecretariatId;
  }

  onSelectedExchangeTypeChange = (value: ExchangeSelectionType) => {
    this._isMounted &&
      this.setState({
        selectedExchangeType: value,
        pharmacyExchangeNeighborSelected: undefined,
        selectedDate: undefined,
        selectedDayOfWeek: undefined,
        requesterDutiesSelected: [],
        neighborDutiesSelected: [],
        neighborDuties: [],
      });
  };

  onSelectedDateChange = async (value: Date) => {
    this._isMounted && this.setState({ neighborDutiesIsLoading: true });
    const { DutyExchangeStore, PharmacyDetailedStore } = this.props;

    const pharmacyIds = this.finalNeighborsList()!
      .filter((p) => p.level > 0)
      .map((p) => p.pharmacyId);
    const neighborDuties = (await DutyExchangeStore!.loadDateDuties(value, pharmacyIds)) as Array<
      Instance<typeof DutyAssignment>
    >;
    this.props.PharmacyDetailedStore!.loadForIds(pharmacyIds);
    const pharmacy: any = value;
    this._isMounted &&
      this.setState({
        pharmacyExchangeNeighborSelected: undefined,
        selectedDate: value,
        requesterDutiesSelected: [],
        neighborDutiesSelected: [],
        bypassedRejected: [],
        neighborDuties,
        neighborDutiesIsLoading: false,
      });
  };

  private finalNeighborsList = () => {
    const pharmacyConnected =
      this.props.AuthenticationStore!.pharmacyId !== null
        ? this.props.PharmacyStore!.getById(this.props.AuthenticationStore!.pharmacyId!)
        : undefined;

    const pharmacyGroup =
      pharmacyConnected !== undefined
        ? this.props.GroupStore!.dataList.find((g) => g.groupId === pharmacyConnected.groupId)
        : undefined;
    return this.state.pharmacyNeighboringList !== undefined
      ? this.state.pharmacyNeighboringList.filter(
        (p) =>
          !this.state.pharmacyUser ||
          pharmacyConnected === undefined ||
          (pharmacyConnected.groupId === p.groupId &&
            (pharmacyConnected.anchorId === undefined ||
              (pharmacyGroup === undefined || !pharmacyGroup.limitExchangeToAnchor) ||
              pharmacyConnected.anchorId === p.anchorId)),
      )
      : undefined;
  };

  onSelectedDayOfWeekChange = async (value: DayOfWeek) => {
    this._isMounted && this.setState({ neighborDutiesIsLoading: true });
    const { DutyExchangeStore, PharmacyDetailedStore } = this.props;
    const pharmacyIds = this.finalNeighborsList()!
      .filter((p) => p.level > 0)
      .map((p) => p.pharmacyId);
    const neighborDuties = (await DutyExchangeStore!.loadDayDuties(value, pharmacyIds)) as Array<
      Instance<typeof DutyAssignment>
    >;
    this.props.PharmacyDetailedStore!.loadForIds(pharmacyIds);
    const pharmacy: any = value;
    this._isMounted &&
      this.setState({
        pharmacyExchangeNeighborSelected: undefined,
        selectedDate: undefined,
        selectedDayOfWeek: value,
        requesterDutiesSelected: [],
        neighborDutiesSelected: [],
        bypassedRejected: [],
        neighborDuties,
        neighborDutiesIsLoading: false,
      });
  };

  render() {
    const {
      pharmacyExchangeRequesterSelected,
      pharmacyExchangeNeighborSelected,
      duties,
      neighborDuties,
      pharmacyNeighboringList,
      pharmacyUser,
      systemStatus,
      requesterDutiesSelected,
      neighborDutiesSelected,
      withAgreement,
      comment,
      withoutSubstitution,
      exchangeItemHistory,
      requestorDutiesIsLoading,
      neighborDutiesIsLoading,
      exchangeIsSaving,
    } = this.state;

    const { PharmacyStore, PharmacyDetailedStore, translate } = this.props;

    const secretariatIdFilter = this.props.UiStore!.pharmaciesSecretariatIdFilter;
    const pharmacyList = PharmacyStore!.dataList.filter(
      (p) =>
        p.level > 0 &&
        p.statusId == 1 &&
        (secretariatIdFilter === undefined || secretariatIdFilter === 0 || p.secretariatId === secretariatIdFilter),
    );

    const pharmacyConnected =
      this.props.AuthenticationStore!.pharmacyId !== null
        ? PharmacyStore!.getById(this.props.AuthenticationStore!.pharmacyId!)
        : undefined;

    const pharmacyGroup =
      pharmacyConnected !== undefined
        ? this.props.GroupStore!.dataList.find((g) => g.groupId === pharmacyConnected.groupId)
        : undefined;

    return (
      <MainSectionLayout isLoading={this.state.isLoading} title={TLCode.EXCHANGE_Title}>
        <Container>
          <Card className={CardStyle.toString()}>
            <Tabs
              id="main"
              defaultSelectedTabId="newExchange"
              renderActiveTabPanelOnly={true}
              onChange={async (newTabId) => {
                if (newTabId === 'history') {
                  await this.ensureHistoryLoaded();
                }
              }}
            >
              <Tab
                id="newExchange"
                title={translate(TLCode.EXCHANGE_NewExchangeTabTitle)}
                panel={
                  <NewExchangeTab
                    onExchangeRequesterSelected={this.onExchangeRequesterSelected}
                    onExchangeNeighborSelected={this.onExchangeNeighborSelected}
                    pharmacyList={pharmacyList}
                    pharmacyNeighboringList={this.finalNeighborsList()}
                    pharmacyRequesterSelected={pharmacyExchangeRequesterSelected}
                    pharmacyNeighborSelected={pharmacyExchangeNeighborSelected}
                    duties={duties}
                    neighborDuties={neighborDuties}
                    onRequesterDutiesSelected={(ids: number[]) => {
                      this.setState({ requesterDutiesSelected: ids });
                      this.onCheckRequesterDutiesSelected(ids);
                    }}
                    onNeighborDutiesSelected={(ids: number[]) => {
                      this.setState({ neighborDutiesSelected: ids });
                      this.onCheckNeighborDutiesSelected(ids);
                    }}
                    onSave={() => this.onSave()}
                    onCheckResult={this.state.onCheckResult}
                    onCancelCheck={() => {
                      this.setState({ onCheckResult: [] });
                      if (this.state.lastSideChanged === 'requester') {
                        this.state.requesterDutiesSelected.pop();
                        this.setState({ requesterDutiesSelected: this.state.requesterDutiesSelected });
                      } else if (this.state.lastSideChanged === 'recipient') {
                        this.state.neighborDutiesSelected.pop();
                        this.setState({ neighborDutiesSelected: this.state.neighborDutiesSelected });
                      }
                    }}
                    onBypassCheck={() => {
                      if (this.state.lastSideChanged === 'requester') {
                        this.state.bypassedRejected.push(
                          this.state.requesterDutiesSelected[this.state.requesterDutiesSelected.length - 1],
                        );
                        this.setState({ bypassedRejected: this.state.bypassedRejected });
                      } else if (this.state.lastSideChanged === 'recipient') {
                        this.state.bypassedRejected.push(
                          this.state.neighborDutiesSelected[this.state.neighborDutiesSelected.length - 1],
                        );
                        this.setState({ bypassedRejected: this.state.bypassedRejected });
                      }
                    }}
                    getPharmacyById={PharmacyStore!.getById}
                    pharmacyUser={pharmacyUser}
                    systemStatus={systemStatus}
                    requesterDutiesSelected={requesterDutiesSelected}
                    neighborDutiesSelected={neighborDutiesSelected}
                    withAgreement={withAgreement}
                    comment={comment}
                    withoutSubstitution={withoutSubstitution}
                    onWithoutSubstitutionChange={this.onWithoutSubstitutionChange}
                    onWithAgreementChange={this.onWithAgreementChange}
                    onCommentChange={this.onCommentChange}
                    requestorDutiesIsLoading={requestorDutiesIsLoading}
                    neighborDutiesIsLoading={neighborDutiesIsLoading}
                    exchangeIsSaving={exchangeIsSaving}
                    isInConflict={this.isInConflict}
                    hasAlreadyDutyOn={this.hasAlreadyDutyOn}
                    checkTooCloseToRequester={this.checkTooCloseToRequester}
                    checkTooCloseToRecipient={this.checkTooCloseToRecipient}
                    lastExchangeItems={this.state.lastExchangeItems}
                    exchangeTypes={[
                      ExchangeSelectionType.ByPharmacy,
                      ExchangeSelectionType.ByDate,
                      ExchangeSelectionType.ByDayOfWeek,
                    ]}
                    selectedExchangeType={this.state.selectedExchangeType}
                    onSelectedExchangeTypeChange={this.onSelectedExchangeTypeChange}
                    selectedDate={this.state.selectedDate}
                    onDateChange={this.onSelectedDateChange}
                    selectedDayOfWeek={this.state.selectedDayOfWeek}
                    onDayOfWeekChange={this.onSelectedDayOfWeekChange}
                  />
                }
              />
              <Tab
                id="history"
                title={translate(TLCode.EXCHANGE_HistoryTabTitle)}
                panel={
                  <ExchangeHistoryTab
                    dutyExchangeList={exchangeItemHistory}
                    exchangeHistoryIsLoading={this.state.exchangeHistoryIsLoading}
                    OnCheckedPastDates={this.switchWithPastDates}
                    isCheckBoxPastDateSelected={!this.state.onlyFutureDutyExchange}
                    secretariatId={this.getSelectedSecretariatId()}
                    onSecretariatIdChanged={async (data) => {
                      await this.loadHistory(data,this.props.AuthenticationStore!.pharmacyId, this.props.AuthenticationStore!.secretariatId);
                    }}
                    onSearchDateChange={this.loadHistory}
                  />
                }
              />
            </Tabs>
          </Card>
        </Container>
      </MainSectionLayout>
    );
  }
}

export default withTranslate(ExchangePage);
